/**
 * Measure target for auth keyboard avoidance — every focusable field must sit in one of these.
 */
import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';

export type AuthFocusTargetProps = {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
};

/**
 * Non-collapsible wrap so `measureInWindow` works on iOS and Android.
 * Pass the same ref into `on_field_focus(ref)` from the child's `onFocus`.
 */
export const AuthFocusTarget = React.forwardRef<View, AuthFocusTargetProps>(function AuthFocusTarget(
  { children, style },
  ref,
) {
  return (
    <View ref={ref} style={style} collapsable={false}>
      {children}
    </View>
  );
});
